import * as _ from "lodash";
import Flash from "@shared/services/flashv2.js";
import moment from "moment";
import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";
import { orderDoesNotMeetTabcSpiritDeliveryMin } from "@retailer/services/cart_order_service";
import CurrentRetailerStore from "@retailer/svelte/stores/CurrentRetailerStore";
import { get } from "svelte/store";

const service = function ($rootScope, CartProduct, C, Discount) {
  const validityCallback = function (vres) {
    if (!$rootScope.cart) {
      $rootScope.cart = {};
    }
    _.each($rootScope.cart.orders || [], function (order) {
      if (!order) {
        return false;
      }
      order.distributor = _.merge(order.distributor, vres.data[order.distributor.id]);
    });
    prepInventory();
    inventoryMatchStrings();
    return vres;
  };

  const savedProductsCallback = function (res) {
    if (!$rootScope.savedProducts) $rootScope.savedProducts = {};
    $rootScope.savedProductsCount = res.data.length;
    const savedProducts = {};
    _.each(res.data, function (sp) {
      if (!_.get(sp, "distributor.name")) {
        return false;
      }
      if (!savedProducts[sp.distributor.name]) {
        savedProducts[sp.distributor.name] = [];
      }
      savedProducts[sp.distributor.name].push(sp);
    });
    $rootScope.savedProducts = savedProducts;
    return res;
  };

  const calculateDollarMinimums = function () {
    _.each($rootScope.cart.orders, function (order) {
      if (
        order.distributor.minimum_dollars_per_order &&
        order.distributor.minimum_dollars_per_order > order.total
      ) {
        order.underDollarMinimum = true;
      } else {
        order.underDollarMinimum = false;
      }
    });
  };

  const cartProductAllocated = function (cartProduct) {
    return (
      (cartProduct.allocation && cartProduct.allocation.is_allocated) ||
      (cartProduct.inventory && cartProduct.orderable == false)
    );
  };

  const cartProductIsAvailable = function (cartProduct, order) {
    if (!order.distributor.available) return true;

    return (
      order.distributor.available?.[cartProduct.product_id] == true &&
      !!cartProduct.inventory_id_for_distributor == true &&
      !cartProduct.hidden
    );
  };

  const prepInventory = function () {
    if (!$rootScope.cart) {
      $rootScope.cart = {};
    }
    $rootScope.inventoryHash = {};
    $rootScope.cart.containsUnavailableProducts = false;
    $rootScope.cart.containsUnconnectedDistributors = false;
    $rootScope.cart.outOfStockProducts = [];
    $rootScope.cart.notSoldAtThisLocationProducts = [];
    $rootScope.cart.productNotFoundProducts = [];
    $rootScope.cart.containsNonOrderableProducts = false;
    $rootScope.cart.containsAllocatedProducts = false;
    $rootScope.cart.containsAlcohol = false;

    _.each(submittableOrders() || [], function (order) {
      if (!order) {
        return false;
      }
      let cpIndex = 0;
      if (order.distributor.connected == false) {
        $rootScope.cart.containsUnconnectedDistributors = true;
      }
      const distributorUsesWineCellar = canUseWineCellar(order.distributor);
      _.each(order.products || [], function (cartProduct) {
        cartProduct.index = cpIndex;
        cpIndex += 1;
        if (distributorUsesWineCellar) {
          cartProduct.allocation = {
            ...cartProduct.allocation,
            is_allocated:
              order.distributor.allocations?.[cartProduct.product_id]?.is_allocated || false,
            amount: order.distributor.allocations?.[cartProduct.product_id]?.amount || 0,
          };
          cartProduct.orderable = order.distributor.orderable?.[cartProduct.product_id] || false;
          cartProduct.product_not_found =
            order.distributor.product_not_found?.[cartProduct.product_id] || false;
        } else {
          cartProduct.orderable = cartProduct.inventory?.orderable;
        }

        if (cartProduct.orderable == false) {
          $rootScope.cart.containsNonOrderableProducts = true;
        }
        cartProduct.is_available = cartProductIsAvailable(cartProduct, order);
        $rootScope.inventoryHash[cartProduct.inventory_id] = cartProduct;
        if (cartProductAllocated(cartProduct)) {
          $rootScope.cart.containsAllocatedProducts = true;
        }
        if (cartProduct.is_available == false) {
          $rootScope.cart.containsUnavailableProducts = true;
        }

        const isOutOfStock = distributorUsesWineCellar
          ? order.distributor.out_of_stock?.[cartProduct.product_id] == true
          : cartProduct.inventory_below_minimum;
        const allocation = cartProduct.allocation || {};
        if (isOutOfStock && !allocation.is_allocated) {
          $rootScope.cart.outOfStockProducts.push(cartProduct);
        }
        if (
          distributorUsesWineCellar &&
          order.distributor.not_sold_at_this_location?.[cartProduct.product_id] == true
        ) {
          $rootScope.cart.notSoldAtThisLocationProducts.push(cartProduct);
        }
        if (cartProduct.product_not_found == true) {
          $rootScope.cart.productNotFoundProducts.push(cartProduct);
        }
        if (
          cartProduct.product_line.product_type_name !== "Non-Alcoholic" &&
          cartProduct.product_line.product_type_name !== "Non-Beverage"
        ) {
          $rootScope.cart.containsAlcohol = true;
        }
      });
    });
  };

  const prepDeliveryDates = function () {
    const delivDateOrders = _.filter($rootScope.cart.orders, function (o) {
      return !_.includes(C.nonDeliveryDistributors, o.distributor.name);
    });
    const nonDelivDateOrders = _.filter($rootScope.cart.orders, function (o) {
      return _.includes(C.nonDeliveryDistributors, o.distributor.name);
    });
    $rootScope.cart.allSameDelivery =
      _.uniq(
        _.map(delivDateOrders, function (o) {
          return o.delivery_date;
        }),
      ).length <= 1;
    if ($rootScope.cart.allSameDelivery) {
      $rootScope.cart.allSameDeliveryDate = ((delivDateOrders || [])[0] || {}).delivery_date;
    }
    _.each(nonDelivDateOrders, function (o) {
      o.delivery_date = moment().add(1, "days").format("YYYY-MM-DDT00:00:00") + "Z";
    });
  };

  const addPlaceholder = function (cartProduct) {
    cartProduct.deleted = true;
    let order = _.find($rootScope.cart.orders, function (o) {
      return o.distributor.id == cartProduct.distributor_id;
    });
    if (!order) {
      order = $rootScope.removedFromOrder;
      if (!order) {
        return;
      }
      order.placeholder = true;
      order.products = [];
      $rootScope.cart.orders = _.concat(order, $rootScope.cart.orders);
      $rootScope.cart.orders = _.sortBy($rootScope.cart.orders, function (o) {
        return _.get(o, "distributor.name");
      });
    }
    order.products = _.concat(cartProduct, order.products);
    order.products = _.sortBy(order.products, function (p) {
      return [p.product_line.name, p.product.id];
    });
  };

  const cartProductByInventory = function (inventory_id) {
    if (!$rootScope.inventoryHash) {
      prepInventory();
    }
    return $rootScope.inventoryHash[inventory_id];
  };

  const inventoryMatchString = function (inventory_id) {
    let cartProduct = cartProductByInventory(inventory_id);
    if (!cartProduct || (!cartProduct.case_quantity && !cartProduct.unit_quantity)) {
      return;
    }
    return CartProduct.inventoryMatchString(cartProduct);
  };

  const inventoryMatchStrings = function () {
    $rootScope.inventoryStrings = {};
    _.each(_.keys($rootScope.inventoryHash), function (inventory_id) {
      $rootScope.inventoryStrings[inventory_id] = inventoryMatchString(inventory_id);
    });
  };

  const runCartChangeEvent = function (res) {
    const cartProduct = this.cartProduct || res;
    if (!cartProduct.product_id) {
      const newCartProduct = cartProductByInventory(cartProduct.inventory_id);
      if (!newCartProduct) {
        return res;
      }
      cartProduct.product_id = newCartProduct.product_id;
      cartProduct.product = newCartProduct.product;
    }
    if (cartProduct.errorRes) {
      if (window.location.pathname === "/cart") {
        Flash.now({
          type: "error",
          message: cartProduct.errorRes.messages.join("\n"),
        });
      }
    }
    return res;
  };

  const submittableOrders = function () {
    return $rootScope.cart.orders?.filter(order => !order.distributor?.ordering_disabled) || [];
  };

  const hasAnyProductsNotAvailable = function () {
    return _.some(submittableOrders(), function (o) {
      if (!o) {
        return false;
      }

      return orderHasAnyProductsNotAvailable(o);
    });
  };

  const orderHasAnyProductsNotAvailable = function (order) {
    return _.some(order.products, function (product) {
      return !product.is_available;
    });
  };

  const hasAnyDistributorsNotConnected = function () {
    return _.some(submittableOrders(), function (o) {
      if (!o) {
        return false;
      }
      return orderDistributorNotConnected(o);
    });
  };

  const orderDistributorNotConnected = function (order) {
    const distributor = order.distributor;

    if (!distributor) return true;

    return !distributor.connected || !distributor.associated;
  };

  const liquorLicenseMissing = function () {
    return $rootScope.cart.containsAlcohol && !$rootScope.getCurrentRetailer()?.liquor_license;
  };

  const orderHasOnlyRequestedItems = function (order) {
    return order.products.every(product => product.requested_item);
  };

  const hasOnlyRequestedItems = function () {
    return submittableOrders().some(order => orderHasOnlyRequestedItems(order));
  };

  const retailerHasNotPaidTXSubscription = function (order) {
    const retailer = get(CurrentRetailerStore);
    return (
      retailer.state === "TX" &&
      retailer?.disable_ordering_for_non_partner_distributor &&
      !order.distributor.texas_partner
    );
  };

  const hasNonTxPartnerOrders = function () {
    return submittableOrders().some(order => retailerHasNotPaidTXSubscription(order));
  };

  const hasProductsOutOfStock = function () {
    return submittableOrders().some(
      order => orderHasProductsOutOfStock(order) && !order.distributor.allow_ordering_out_of_stock,
    );
  };

  const orderHasProductsOutOfStock = function (order) {
    if (!$rootScope.cart.outOfStockProducts) return false;

    return $rootScope.cart.outOfStockProducts.some(product => product.order_id === order.id);
  };

  const orderHasProductsNotSoldAtThisLocation = order => {
    if (!$rootScope.cart.notSoldAtThisLocationProducts) return false;

    return $rootScope.cart.notSoldAtThisLocationProducts.some(
      product => product.order_id === order.id,
    );
  };

  const orderHasNonOrderableProducts = order => {
    if (!$rootScope.cart.containsNonOrderableProducts) return false;
    return order.products.some(product => product.orderable == false);
  };

  const hasNonOrderableProducts = function () {
    return $rootScope.cart.containsNonOrderableProducts;
  };

  const orderHasProductNotFoundProducts = order => {
    if (!$rootScope.cart.productNotFoundProducts) return false;
    return $rootScope.cart.productNotFoundProducts.some(product => product.order_id === order.id);
  };

  const deliveryMinimumCallback = function (res, order) {
    if (!res) {
      return;
    }
    order.tabc_spirit_delivery_remaining = res.data["gal_amount_remaining"];
  };

  const doesNotMeetTabcSpiritDeliveryMin = function () {
    return submittableOrders().some(order => {
      if (!order.tabc_spirit_delivery_remaining) return false;
      if (order.tabc_spirit_delivery_remaining > 0) return true;
    });
  };

  const minimumOrderQuantityCallback = function (res, order) {
    if (!res) return;
    order.minimum_order_quantity_reached = res.data["minimum_order_quantity_reached"];
  };

  const doesNotMeetMinimumOrderQuantity = function () {
    return submittableOrders().some(order => {
      return order.minimum_order_quantity_reached == false;
    });
  };

  const orderDoesNotMeetMinimumOrderQuantity = function (order) {
    return order.minimum_order_quantity_reached == false;
  };

  const hasUnconfirmedAutoMatchedDistributor = function () {
    return submittableOrders().some(order => orderHasUnconfirmedAutoMatchedDistributor(order));
  };

  const isBelowMandatoryMinimum = function () {
    return submittableOrders().some(order => orderIsBelowMandatoryMinimum(order));
  };

  const requiresRetailerUserAuthentication = function () {
    return submittableOrders().some(order => {
      return (
        order?.distributor?.reasons?.retailer_user_authentication_status == "pending" ||
        order?.distributor?.reasons?.retailer_user_authentication_status == "invalid"
      );
    });
  };

  const orderHasUnconfirmedAutoMatchedDistributor = function (order) {
    return (
      order.distributor.distributor_account_id &&
      order.distributor.reasons?.requires_match_confirmation === true
    );
  };

  const orderDistributorNotAcceptingOrders = function (order) {
    return order.distributor.ordering_disabled;
  };

  const orderIsBelowMandatoryMinimum = function (order) {
    return order.distributor.reasons?.needs_to_reach_order_minimum === true;
  };

  const integratedDistributorsBlockedOnCustomOrderBlockingFlag = function () {
    if (!$rootScope.cart) {
      $rootScope.cart = {};
    }

    let distributorsBlockedOnCustomOrderBlockingFlag = [];

    _.forEach(submittableOrders(), function (order) {
      if (!order) {
        return false;
      }

      if (
        order.distributor.integrated_custom_order_blocking &&
        order.distributor_account_config?.should_block_orders != false
      ) {
        distributorsBlockedOnCustomOrderBlockingFlag.push(order.distributor.name);
      }
    });

    return distributorsBlockedOnCustomOrderBlockingFlag;
  };

  const orderBlockedOnCustomOrderBlockingFlag = function (order) {
    return (
      order.distributor.integrated_custom_order_blocking &&
      order.distributor_account_config?.should_block_orders != false
    );
  };
  const orderConnectedAccountInactive = function (order) {
    return order.distributor.reasons?.connected_account_inactive === true;
  };
  const hasAnyOrdersWithConnectedAccountInactive = function () {
    return $rootScope.cart.orders?.some(order => orderConnectedAccountInactive(order));
  };

  const canUseWineCellar = distributor =>
    stagedRolloutCheck("marketplace__fulfillment_methods") && distributor?.uses_wine_cellar;

  return {
    validityCallback,
    savedProductsCallback,
    calculateDollarMinimums,
    prepInventory,
    prepDeliveryDates,
    addPlaceholder,
    runCartChangeEvent,
    cartProductByInventory,
    inventoryMatchString,
    inventoryMatchStrings,
    hasAnyProductsNotAvailable,
    orderHasAnyProductsNotAvailable,
    hasAnyDistributorsNotConnected,
    orderDistributorNotConnected,
    liquorLicenseMissing,
    hasProductsOutOfStock,
    orderHasProductsOutOfStock,
    orderHasProductsNotSoldAtThisLocation,
    orderHasNonOrderableProducts,
    hasNonOrderableProducts,
    orderHasProductNotFoundProducts,
    orderHasOnlyRequestedItems,
    hasOnlyRequestedItems,
    retailerHasNotPaidTXSubscription,
    hasNonTxPartnerOrders,
    deliveryMinimumCallback,
    minimumOrderQuantityCallback,
    doesNotMeetTabcSpiritDeliveryMin,
    doesNotMeetMinimumOrderQuantity,
    integratedDistributorsBlockedOnCustomOrderBlockingFlag,
    orderBlockedOnCustomOrderBlockingFlag,
    orderDoesNotMeetTabcSpiritDeliveryMin,
    orderDoesNotMeetMinimumOrderQuantity,
    hasUnconfirmedAutoMatchedDistributor,
    orderHasUnconfirmedAutoMatchedDistributor,
    orderDistributorNotAcceptingOrders,
    isBelowMandatoryMinimum,
    orderIsBelowMandatoryMinimum,
    requiresRetailerUserAuthentication,
    orderConnectedAccountInactive,
    hasAnyOrdersWithConnectedAccountInactive,
  };
};

export default service;
